var filterProductNumberTable = function(){
	const $partsTableWrapper = $('#product-tab-section-part-numbers-specifications');
	const $partsTableRows = $partsTableWrapper.find('table tbody tr');
	const $filterClear = $partsTableWrapper.find('.clear-product-filters-wrapper');
	var currentFilters = {};
	var hasFilters = false;

	$('[data-parts-filter]').each(function(){
		const $this = $(this);
		const selectValue = $this.val();
		if( selectValue !== 'disabled' && selectValue !== null && selectValue !== '-1' ) {
			hasFilters = true;
			currentFilters[$this.attr('data-parts-filter')] = selectValue;
			$('[data-parts-filter="' + $this.attr('data-parts-filter') + '"]').each(function(){
				$(this).closest('.select-wrap').addClass('select-wrap--active');
			})
		} else {
			$('[data-parts-filter="' + $this.attr('data-parts-filter') + '"]').each(function(){
				$(this).closest('.select-wrap').removeClass('select-wrap--active');
			})
		}
	})
	
	$partsTableRows.each(function(){
		var check = 1;
		var $trelem = $(this);
		$.each(currentFilters, function(key, value){
			if( $trelem.attr('data-parts-filter-' + key) != value ) {
				check = 0;
			}
		})
		if( check == 0 ) {
			$(this).hide();
		} else {
			$(this).show();
		}
	});

	$partsTableWrapper.find('.table-overflow').show();
	$partsTableRows.filter(':visible:odd').attr('data-row', 'odd');
	$partsTableRows.filter(':visible:even').attr('data-row', 'even');

	if( $partsTableRows.filter(':visible').length == 0 ) {
		$partsTableWrapper.find('.parts-table-no-results').show();
		$partsTableWrapper.find('.table-overflow, .caption--table').hide();
		$filterClear.show();
	} else {
		$partsTableWrapper.find('.parts-table-no-results').hide();
		$partsTableWrapper.find('.table-overflow, .caption--table').show();
		if( hasFilters ) {
			$filterClear.show();
		} else {
			$filterClear.hide();
		}
	}

	smooth_scroll( $partsTableWrapper.find('.product-module--table'), 0 );
};

$(document).on('change', '[data-parts-filter]', function(){
	// SET DUPLICATE FILTERS
	const $this = $(this);
	const selectValue =  $this.val();
	$('[data-parts-filter="' + $this.attr('data-parts-filter') + '"]').each(function(){
		if( $(this).val() != selectValue ) {
			$(this).val(selectValue).trigger('change');
			return false;
		}
	})
	filterProductNumberTable();
});

$(document).on('click', '[data-clear-product-filters]', function(e){
	e.preventDefault();
	$('[data-parts-filter]').each(function(){
		$(this).val('-1').trigger('change');
	});
})